import SearchInputWrapper from './SearchInputWrapper';

export default SearchInputWrapper;
